<template>
  <div class="mx-auto max-w-xl py-2">
    <div class="breadcrumbs mb-2">
      <NuxtLink :to="{ name: 'teams' }">{{ $t('shared.nav.teams') }}</NuxtLink>
    </div>
    <h1 class="font-heading font-bold text-2xl" v-html="$t('pages.teams.heading')" />
    <!-- <div class="box bg-red-500/10 text-center p-6 my-2">Search?</div> -->
    <div class="space-y-6 mt-4" v-auto-animate>
      <div v-for="league in leagues" :key="league.key" class="space-y-2">
        <div class="flex items-center gap-2">
          <LeagueLogo
            v-if="league.slug"
            class="w-8 h-8 rounded-md overflow-hidden"
            :name="league.name"
            :slug="league.slug"
          />
          <h2 class="font-heading font-bold text-xl">{{ league.name }}</h2>
        </div>
        <div class="space-y-2">
          <NuxtLink
            v-for="team in league.teams"
            :key="team.id"
            :to="{ name: 'team', params: { team: team.slug } }"
            class="flex items-center gap-2 rounded-md border bg-white px-2 py-2"
          >
            <TeamLogo
              class="block w-7 h-7"
              :name="team.name"
              :slug="team.slug"
              :logo="team.logo"
              size="64"
              :alt="team.abbr"
            />
            <span class="font-bold">{{ team.name }}</span>
          </NuxtLink>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
const route = useRoute()

const { data } = useFetch('/api/v1/teams', {
  key: 'teams',
  baseURL: useEnv('apiBase'),
})

const leagues = computed(() => {
  const groups = new Map()

  for (const team of data.value?.teams || []) {
    const league = team?.league || {}
    const key = league?.slug

    if (league?.slug) { 
      if (!groups.has(key)) {
        groups.set(key, {
          key,
          id: league.id ?? null,
          name: league.name || 'Other Teams',
          slug: league.slug || null,
          teams: []
        })
      }

      groups.get(key).teams.push(team)
    }
  }

  return [...groups.values()]
    .map(group => ({
      ...group,
      teams: [...group.teams]
        ?.sort((a, b) => a?.name.localeCompare(b?.name))
    }))
    .sort((a, b) => a?.name.localeCompare(b?.name))
})
</script>